import { Injectable, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Injector, Component, NgModule } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { of, BehaviorSubject, concat, isObservable, from } from 'rxjs';
import { template } from 'lodash';
import { filter, concatMap, mergeMap, distinct, toArray, first, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

function PpBreadcrumbsComponent_ol_0_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "a", 6);
} if (rf & 2) {
    const crumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", crumb_r2.path)("innerHTML", crumb_r2.text, ɵngcc0.ɵɵsanitizeHtml);
} }
function PpBreadcrumbsComponent_ol_0_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 7);
} if (rf & 2) {
    const crumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", crumb_r2.text, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c0 = function (a0) { return { "active": a0 }; };
function PpBreadcrumbsComponent_ol_0_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtemplate(1, PpBreadcrumbsComponent_ol_0_li_1_a_1_Template, 1, 2, "a", 4);
    ɵngcc0.ɵɵtemplate(2, PpBreadcrumbsComponent_ol_0_li_1_ng_template_2_Template, 1, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const last_r4 = ctx.last;
    const _r6 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, last_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r4)("ngIfElse", _r6);
} }
function PpBreadcrumbsComponent_ol_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ol", 1);
    ɵngcc0.ɵɵtemplate(1, PpBreadcrumbsComponent_ol_0_li_1_Template, 4, 5, "li", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.crumbs);
} }
class PpBreadcrumbsResolver {
    resolve(route, state) {
        const data = route.routeConfig.data;
        const path = this.getFullPath(route);
        const rawText = typeof data.breadcrumbs === 'string' ? data.breadcrumbs : data.breadcrumbs.text || data.text || path;
        return of([
            {
                path: path,
                text: this.stringFormat(rawText, route.data)
            }
        ]);
    }
    getFullPath(route) {
        const relativePath = (segments) => segments.reduce((a, v) => (a += '/' + v.path), '');
        const fullPath = (routes) => routes.reduce((a, v) => (a += relativePath(v.url)), '');
        return fullPath(route.pathFromRoot);
    }
    stringFormat(templateString, binding) {
        const compiled = template(templateString, { interpolate: /{{(.+?)}}/g });
        return compiled(binding);
    }
}
PpBreadcrumbsResolver.ɵfac = function PpBreadcrumbsResolver_Factory(t) { return new (t || PpBreadcrumbsResolver)(); };
PpBreadcrumbsResolver.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PpBreadcrumbsResolver, factory: PpBreadcrumbsResolver.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PpBreadcrumbsResolver, [{
        type: Injectable
    }], null, null); })();

class PpBreadcrumbsService {
    constructor(router, injector) {
        this.router = router;
        this.injector = injector;
        this.breadcrumbs = new BehaviorSubject([]);
        this.defaultResolver = new PpBreadcrumbsResolver();
        this.subscription = this.router.events.pipe(filter(x => x instanceof NavigationEnd), concatMap(() => this.onNavigationEnd())).subscribe();
        this.onNavigationEnd().subscribe();
    }
    get crumbs$() {
        return this.breadcrumbs.asObservable();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.breadcrumbs.complete();
    }
    onNavigationEnd() {
        return this.resolveCrumbs(this.router.routerState.snapshot.root).pipe(mergeMap((breadcrumbs) => breadcrumbs), distinct((breadcrumb) => breadcrumb.text), toArray(), mergeMap((breadcrumbs) => {
            return this.postProcess ? this.wrapIntoObservable(this.postProcess(breadcrumbs)).pipe(first()) : of(breadcrumbs);
        }), tap((breadcrumbs) => this.breadcrumbs.next(breadcrumbs)));
    }
    resolveCrumbs(route) {
        var _a;
        let crumbs$ = of([]);
        const data = (_a = route.routeConfig) === null || _a === void 0 ? void 0 : _a.data;
        if (data === null || data === void 0 ? void 0 : data.breadcrumbs) {
            const resolver = this.getBreadcrumbResolver(data.breadcrumbs);
            const result = resolver.resolve(route, this.router.routerState.snapshot);
            crumbs$ = this.wrapIntoObservable(result).pipe(first());
        }
        return route.firstChild ? concat(crumbs$, this.resolveCrumbs(route.firstChild)) : crumbs$;
    }
    getBreadcrumbResolver(breadcrumbs) {
        return typeof breadcrumbs === 'function' && breadcrumbs.prototype instanceof PpBreadcrumbsResolver
            ? this.injector.get(breadcrumbs)
            : this.defaultResolver;
    }
    wrapIntoObservable(value) {
        return isObservable(value) ? value : from(Promise.resolve(value));
    }
}
PpBreadcrumbsService.ɵfac = function PpBreadcrumbsService_Factory(t) { return new (t || PpBreadcrumbsService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
PpBreadcrumbsService.ɵprov = ɵɵdefineInjectable({ factory: function PpBreadcrumbsService_Factory() { return new PpBreadcrumbsService(ɵɵinject(Router), ɵɵinject(INJECTOR)); }, token: PpBreadcrumbsService, providedIn: "root" });
PpBreadcrumbsService.ctorParameters = () => [
    { type: Router },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PpBreadcrumbsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc0.Injector }]; }, null); })();

class PpBreadcrumbsComponent {
    constructor(service) {
        this.service = service;
    }
    ngOnInit() {
        this.subscription = this.service.crumbs$.subscribe((crumbs) => {
            this.crumbs = crumbs;
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
PpBreadcrumbsComponent.ɵfac = function PpBreadcrumbsComponent_Factory(t) { return new (t || PpBreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(PpBreadcrumbsService)); };
PpBreadcrumbsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PpBreadcrumbsComponent, selectors: [["pp-breadcrumbs"]], decls: 1, vars: 1, consts: [["class", "breadcrumb", 4, "ngIf"], [1, "breadcrumb"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item", 3, "ngClass"], [3, "routerLink", "innerHTML", 4, "ngIf", "ngIfElse"], ["lastBreadcrumb", ""], [3, "routerLink", "innerHTML"], [3, "innerHTML"]], template: function PpBreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PpBreadcrumbsComponent_ol_0_Template, 2, 1, "ol", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.crumbs.length);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc1.RouterLinkWithHref], styles: [""] });
PpBreadcrumbsComponent.ctorParameters = () => [
    { type: PpBreadcrumbsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PpBreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'pp-breadcrumbs',
                template: "<ol *ngIf=\"crumbs.length\" class=\"breadcrumb\">\r\n  <li *ngFor=\"let crumb of crumbs; let first = first; let last = last\" [ngClass]=\"{ 'active': last }\" class=\"breadcrumb-item\">\r\n    <a *ngIf=\"!last; else lastBreadcrumb\" [routerLink]=\"crumb.path\" [innerHTML]=\"crumb.text\"></a>\r\n    <ng-template #lastBreadcrumb>\r\n      <span [innerHTML]=\"crumb.text\"></span>\r\n    </ng-template>\r\n  </li>\r\n</ol>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: PpBreadcrumbsService }]; }, null); })();

class PpBreadcrumbsModule {
}
PpBreadcrumbsModule.ɵfac = function PpBreadcrumbsModule_Factory(t) { return new (t || PpBreadcrumbsModule)(); };
PpBreadcrumbsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PpBreadcrumbsModule });
PpBreadcrumbsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, RouterModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PpBreadcrumbsModule, [{
        type: NgModule,
        args: [{
                declarations: [PpBreadcrumbsComponent],
                imports: [CommonModule, RouterModule],
                exports: [PpBreadcrumbsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PpBreadcrumbsModule, { declarations: function () { return [PpBreadcrumbsComponent]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [PpBreadcrumbsComponent]; } }); })();

/*
 * Public API Surface of pp-breadcrumbs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PpBreadcrumbsComponent, PpBreadcrumbsModule, PpBreadcrumbsResolver, PpBreadcrumbsService };

